import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { campaignNoteFromServer, campaignNoteToServer } from 'models/campaign-notes-model'
import { del, get, post } from 'utils/http'

// Notes list for a campaign (the proxy custom-enriches each note with its user).
export const useCampaignNotes = (campaignId: any) =>
  useQuery({
    queryKey: ['campaignNotes', campaignId],
    queryFn: async () => {
      const notes = await get(`/management/campaigns/${campaignId}/notes`)
      return (notes || []).map(campaignNoteFromServer)
    },
    enabled: !!campaignId,
    initialData: [],
  })

// Create/delete always refetch (parity with the old swallowing thunk) via invalidate in onSettled.
export const useCreateCampaignNote = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ campaignId, payload }: any) =>
      post(`/management/campaigns/${campaignId}/notes`, campaignNoteToServer(payload)),
    onSettled: (_d, _e, { campaignId }: any) =>
      queryClient.invalidateQueries({ queryKey: ['campaignNotes', campaignId] }),
  })
}

export const useDeleteCampaignNote = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ campaignId, noteId }: any) => del(`/management/campaigns/${campaignId}/notes/${noteId}`),
    onSettled: (_d, _e, { campaignId }: any) =>
      queryClient.invalidateQueries({ queryKey: ['campaignNotes', campaignId] }),
  })
}
